Vue.use(Vuex);

import user from '../customer/index';
import viewer from '../viewer/store';
import checkTracker from '../check-tracker/store';
import worker from '../worker/store';

const defaultState = {
    fetchingOngoingTasks: false,
    down: false,
    session: null,
    ready: false,
    devtool: process.env.NODE_ENV !== 'production',
    devtoolAddonComponent: null,
    loader: 0
};

export default new Vuex.Store({
    state: JSON.parse(JSON.stringify(defaultState)),
    mutations: {
        setDevtoolAddonComponent: (state, value) => state.devtoolAddonComponent = value,
        setUnavailable: (state) => state.down = true,
        setSession: (state, session) => state.session = session,
        updateSession: (state, session) => {
            state.session.first_name = session.first_name;
            state.session.last_name = session.last_name;
            state.session.email = session.email;
        },
        toggleDevtool: (state) => state.devtool = !state.devtool,
        unsetUserPromises: (state) => user.unsetPromises(),
        resetApplication: (state) => {
            const initialState = JSON.parse(JSON.stringify(defaultState));
            for (let key in initialState) state[key] = initialState[key];
        },
        setSessionSuperuser: (state, value) => {
            state.session.is_qa = false;
            state.session.is_manager = false;
            state.session.is_worker = false;
            state.session.is_staff = value;
        },
        setSessionEnterprise: (state, value) => state.session.isEnterprise = value,
        setUnready: (state) => state.ready = false,
        setReady: (state) => state.ready = true,
        showLoader: (state) => ++state.loader,
        hideLoader: (state) => -- state.loader,
    },
    getters: {
        hash,
        production,
        status
    },
    actions: {
        fetchOngoingTasks: fetchOngoingTasks,
        startSession: startSession,
        resetApplication: (context) => {
            context.commit('resetApplication');
            context.commit('unsetUserPromises');
        }
    },
    modules: {
        viewer,
        checkTracker,
        worker,
    }
});

function status(state) {
    if (!state.ready) return 'loading'
    if (state.down) return 'down'
    if (state.session) return 'authenticated'
    if (!state.session) return 'anonymous'
    return 'down'
}

function production() {
    return process.env.NODE_ENV === 'production';
}

function hash() {
    if (!process.env.CIRCLE_SHA1) return;
    return process.env.CIRCLE_SHA1.slice(0, 7);
}

function fetchOngoingTasks(context) {
    context.commit('fetchingOngoingTasks')
}

function startSession(context, session) {
    if (context.state.session) return;

    return user
        .sessionPromise
        .then((session) => {
            context.commit('setSession', session);

            if (window._mfq) {
                const impersonating = !!session.original_user_email;
                _mfq.push(["setVariable", "username", session.original_user_email || session.email]);
                _mfq.push(["setVariable", "impersonating", impersonating]);
                _mfq.push(["setVariable", "environment", process.env.CIRCLE_BRANCH || 'local']);
                _mfq.push(["setVariable","isCustomer",session.isCustomer]);
                if (!session.isCustomer) {
                    if(session.is_manger) {
                        _mfq.push(["setVariable", "manager", session.last_name || 'Unknown']);
                    } else if(session.is_qa) {
                        _mfq.push(["setVariable", "qa", session.last_name || 'Unknown']);
                    } else if(session.is_worker) {
                        _mfq.push(["setVariable", "researcher", session.last_name || 'Unknown']);
                    }
                } else {
                    _mfq.push(["setVariable", "client", session.email || 'Unknown']);
                    _mfq.push(["setVariable", "clientCategory", session.user_profile.category]);
                }
            }

            Sentry.configureScope(function(scope) {
              scope.setUser({"email": session.email});
            });
            Sentry.configureScope(function(scope) {
              scope.setTag("impersonator", session.original_user_email);
            });
        })
        .then(() => context.dispatch('fetchProjects'))
        .catch((err) => {
            if (err.status === 403) {
                context.commit('setSession', null);
                return;
            }

            context.commit('setUnavailable');
            if (!context.getters.production) console.error(err);
        });
}
